/* eslint-disable no-param-reassign */
import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@sainsburys-tech/bolt';
import * as Styled from '../../Footer.styles';
import { copyrightConfig, legalLinks } from './Legal.Template';

var ensureStructure = function ensureStructure(window) {
  window.digitalData = window.digitalData || {};
  window.digitalData.event = window.digitalData.event || [];

  window.digitalData.track = window.digitalData.track || function () {};
};

var Legal = function Legal(_ref) {
  var _ref$legal = _ref.legal,
      legal = _ref$legal === void 0 ? {
    legalText: ''
  } : _ref$legal,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$creditHidden = _ref.creditHidden,
      creditHidden = _ref$creditHidden === void 0 ? false : _ref$creditHidden,
      _ref$paypalCreditHidd = _ref.paypalCreditHidden,
      paypalCreditHidden = _ref$paypalCreditHidd === void 0 ? false : _ref$paypalCreditHidd,
      _ref$paypalCredit = _ref.paypalCredit,
      paypalCredit = _ref$paypalCredit === void 0 ? {
    aprText: '',
    legalText: '',
    logo: {
      key: '',
      src: '',
      alt: ''
    }
  } : _ref$paypalCredit,
      _ref$paypalExampleHid = _ref.paypalExampleHidden,
      paypalExampleHidden = _ref$paypalExampleHid === void 0 ? false : _ref$paypalExampleHid,
      _ref$showCarePolicy = _ref.showCarePolicy,
      showCarePolicy = _ref$showCarePolicy === void 0 ? false : _ref$showCarePolicy,
      _ref$hideCookieList = _ref.hideCookieList,
      hideCookieList = _ref$hideCookieList === void 0 ? false : _ref$hideCookieList;

  var onCookiePreferencesClick = function onCookiePreferencesClick(evt) {
    onClick(evt, 'cookiePreferences');
    ensureStructure(window);
    var event = {
      eventInfo: {
        eventAction: 'Update Consent Preference',
        eventName: 'updateConsentPreference'
      }
    };
    window.digitalData.event.push(event);
    window.digitalData.track(event.eventInfo.eventName);
  };

  var onClickHandler = function onClickHandler(evt, onClickParam) {
    return onClickParam === 'onCookiePreferencesClick' ? onCookiePreferencesClick(evt) : onClick(evt, onClickParam);
  };

  return /*#__PURE__*/React.createElement(Styled.Legal, null, /*#__PURE__*/React.createElement("div", {
    className: "no-line-height"
  }, legalLinks.map(function (_ref2) {
    var dataTest = _ref2.dataTest,
        href = _ref2.href,
        rel = _ref2.rel,
        target = _ref2.target,
        text = _ref2.text,
        linkType = _ref2.type,
        onClickParam = _ref2.onClickParam;
    return text && (dataTest !== 'footer-cookie-list' || !hideCookieList) && /*#__PURE__*/React.createElement(Styled.LegalLink, {
      key: text,
      "data-test": dataTest && dataTest,
      href: href && href,
      rel: rel && rel,
      target: target && target,
      onClick: onClickParam ? function (evt) {
        return onClickHandler(evt, onClickParam);
      } : undefined,
      as: linkType && linkType,
      "aria-haspopup": linkType === 'button' ? true : null
    }, text);
  })), /*#__PURE__*/React.createElement(Styled.LegalCopyRightText, {
    className: "no-line-height",
    "data-test": "footer-copyright"
  }, copyrightConfig.copyRightText), /*#__PURE__*/React.createElement(Styled.LegalContainer, {
    className: "container container--column"
  }, !paypalExampleHidden && !paypalCreditHidden && paypalCredit.aprText && /*#__PURE__*/React.createElement(Styled.LegalRow, {
    className: "md-row"
  }, /*#__PURE__*/React.createElement(Styled.LegalPaypalLogoAPR, null, /*#__PURE__*/React.createElement(Styled.LegalPayPalLogo, null, /*#__PURE__*/React.createElement(Image, {
    key: paypalCredit.logo.key,
    src: paypalCredit.logo.src,
    alt: paypalCredit.logo.alt,
    quality: 80,
    width: 106,
    height: 46,
    "data-test": "paypal-credit-logo",
    responsive: true,
    lazy: true,
    nativeLazy: false,
    lazyWrapElement: "span"
  })), /*#__PURE__*/React.createElement(Styled.LegalText, {
    className: "no-line-height",
    "data-test": "paypal-credit-apr"
  }, paypalCredit.aprText))), !creditHidden && /*#__PURE__*/React.createElement(Styled.LegalRow, {
    className: "md-row"
  }, /*#__PURE__*/React.createElement(Styled.LegalText, {
    className: "no-line-height",
    "data-test": "footer-legalcopy"
  }, legal.legalText)), !paypalCreditHidden && paypalCredit.aprText !== '' && /*#__PURE__*/React.createElement(Styled.LegalRow, null, /*#__PURE__*/React.createElement(Styled.LegalText, {
    className: "no-line-height",
    "data-test": "paypal-credit-legal"
  }, paypalCredit.legalText)), showCarePolicy && !creditHidden && /*#__PURE__*/React.createElement(Styled.LegalRow, {
    className: "md-row"
  }, /*#__PURE__*/React.createElement(Styled.LegalText, {
    className: "no-line-height",
    "data-test": "footer-care-policy"
  }, legal.carePolicyText))));
};

Legal.propTypes = {
  onClick: PropTypes.func,
  creditHidden: PropTypes.bool,
  legal: PropTypes.shape({
    legalText: PropTypes.string
  }),
  paypalCreditHidden: PropTypes.bool,
  paypalCredit: PropTypes.shape({
    aprText: PropTypes.string,
    legalText: PropTypes.string,
    logo: PropTypes.shape({
      key: PropTypes.string,
      src: PropTypes.string,
      alt: PropTypes.string
    })
  }),
  paypalExampleHidden: PropTypes.bool,
  showCarePolicy: PropTypes.bool
};
export default Legal;